import axios from "axios";
import { LOYALTY_USER_URL } from "../ApiConstant";

export const loadingLoyaltyUser = () => {
  return {
    type: "LOADING_LOYALTY_USER",
  };
};

export const loyaltyUserSuccess = (data) => {
  return {
    type: "LOYALTY_USER_SUCCESS",
    data: data,
  };
};

export const loyaltyUserError = (error) => {
  return {
    type: "LOYALTY_USER_ERROR",
    error: error,
  };
};

export const fetchLoyaltyUser = () => {
  return (dispatch) => {
    dispatch(loadingLoyaltyUser());
    axios
      .get(LOYALTY_USER_URL)
      .then((response) => {
        dispatch(loyaltyUserSuccess(response.data));
      })
      .catch((error) => {
        dispatch(loyaltyUserError(error));
      });
  };
};
